import React from 'react';
import Input from '../../../components/input';
import ErrorMessage from '../../../components/error_message';
import Textarea from '../../../components/textarea';
import Checkbox from '../../../components/checkbox';

interface EditSequenceContactNotePayloadProps {
  payload: any;
  stepIndex: number;
  updatePayload: (payload: any, stepIndex: number) => void;
  displayValidationErrors: boolean;
}

const EditSequenceContactNotePayload = ({
  payload,
  stepIndex,
  updatePayload,
  displayValidationErrors,
}: EditSequenceContactNotePayloadProps) => {
  const onUpdate = (updated) => {
    updatePayload({ ...payload, ...updated }, stepIndex);
  };

  return (
    <div className="template-details">
      <div className="row form-group">
        <div className="col-sm-4 col-lg-4">
          <label className="control-label">Note subject</label>
        </div>
        <div className="col-sm-8 col-lg-8">
          <Input
            value={payload.note_subject}
            onChange={(note_subject) => onUpdate({ note_subject })}
          />

          {displayValidationErrors && !payload.note_subject?.trim() && (
            <ErrorMessage error="Is required" />
          )}
        </div>
      </div>
      <div className="row form-group">
        <div className="col-sm-4 col-lg-4">
          <label className="control-label">Note body</label>
        </div>
        <div className="col-sm-8 col-lg-8">
          <Textarea value={payload.note_body} onChange={(note_body) => onUpdate({ note_body })} />

          {displayValidationErrors && !payload.note_body?.trim() && (
            <ErrorMessage error="Is required" />
          )}
        </div>
      </div>

      <div className="form-group">
        <Checkbox
          checked={payload.skip_if_matching_note_exists}
          onChange={(skip_if_matching_note_exists) => onUpdate({ skip_if_matching_note_exists })}
        >
          Skip this step, if contact already has a note with the same subject and description?
        </Checkbox>
      </div>
    </div>
  );
};

angular.module('gym').value('EditSequenceContactNotePayload', EditSequenceContactNotePayload);
